import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { getCurrentSlice } from 'utils';
import Range from './range/Range';
import InputText from './input-text/InputText';
import Checkboxes from './checkboxes/Checkboxes';
import { StyledContentBasedFilter } from './ContentBasedFilter.styles';

/**
 * فیلتر انتخاب مطالب بر‌اساس
 */
export const ContentBasedFilter = (props) => {
  const dispatch = useDispatch();
  const { componentName, parentPlatform, className } = props;
  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedObjects } = filter;
  const { setSelectedContentBasedValues } = getCurrentSlice(reducerName);

  const handleSubFilterChange = ({ keyName, active, min, max, type, id }) => {
    dispatch(
      setSelectedContentBasedValues({
        keyName,
        active,
        min,
        max,
        componentName,
        parentPlatform,
        type,
        id,
      })
    );
  };

  return (
    <StyledContentBasedFilter>
      <div className={classNames('filter-content-based rtl mb-15', className)}>
        {Object.keys(selectedObjects)?.map((key) => {
          if (selectedObjects?.[key]?.type === 'range')
            return (
              <Range
                key={key}
                options={selectedObjects?.[key]}
                keyName={key}
                onSubFilterChange={handleSubFilterChange}
                toggler={selectedObjects[key].toggler}
              />
            );
          if (selectedObjects?.[key]?.type === 'text')
            return (
              <InputText
                key={key}
                options={selectedObjects?.[key]}
                keyName={key}
                onSubFilterChange={handleSubFilterChange}
                toggler={selectedObjects[key].toggler}
              />
            );
          if (selectedObjects?.[key]?.type === 'checkboxes') {
            return (
              <Checkboxes
                key={key}
                options={selectedObjects[key]}
                keyName={key}
                onSubFilterChange={handleSubFilterChange}
                toggler={selectedObjects[key].toggler}
              />
            );
          }
        })}
      </div>
    </StyledContentBasedFilter>
  );
};

ContentBasedFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
